/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "селхана",
        "0": "тахана",
        "1": "кхана",
        "future": {
          "one": "{0} де даьлча",
          "other": "{0} де даьлча"
        },
        "past": {
          "one": "{0} де хьалха",
          "other": "{0} де хьалха"
        }
      },
      "day-narrow": {
        "-1": "селхана",
        "0": "тахана",
        "1": "кхана",
        "future": {
          "one": "{0} д. даьлча",
          "other": "{0} д. даьлча"
        },
        "past": {
          "one": "де хьалха",
          "other": "{0} де хьалха"
        }
      },
      "day-short": {
        "-1": "селхана",
        "0": "тахана",
        "1": "кхана",
        "future": {
          "one": "{0} д. даьлча",
          "other": "{0} д. даьлча"
        },
        "past": {
          "one": "{0} д. хьалха",
          "other": "{0} де хьалха"
        }
      },
      "hour": {
        "0": "хӀокху сахьтехь",
        "future": {
          "one": "{0} сахьт даьлча",
          "other": "{0} сахьт даьлча"
        },
        "past": {
          "one": "{0} сахьт хьалха",
          "other": "{0} сахьт хьалха"
        }
      },
      "hour-narrow": {
        "0": "хӀокху сахьтехь",
        "future": {
          "one": "{0} сахь. даьлча",
          "other": "{0} сахь. даьлча"
        },
        "past": {
          "one": "{0} сахь. хьалха",
          "other": "{0} сахь. хьалха"
        }
      },
      "hour-short": {
        "0": "хӀокху сахьтехь",
        "future": {
          "one": "{0} сахь. даьлча",
          "other": "{0} сахь. даьлча"
        },
        "past": {
          "one": "{0} сахь. хьалха",
          "other": "{0} сахь. хьалха"
        }
      },
      "minute": {
        "0": "хӀокху минотехь",
        "future": {
          "one": "{0} минот яьлча",
          "other": "{0} минот яьлча"
        },
        "past": {
          "one": "{0} минот хьалха",
          "other": "{0} минот хьалха"
        }
      },
      "minute-narrow": {
        "0": "хӀокху минотехь",
        "future": {
          "one": "{0} мин. яьлча",
          "other": "{0} мин. яьлча"
        },
        "past": {
          "one": "{0} мин. хьалха",
          "other": "{0} мин. хьалха"
        }
      },
      "minute-short": {
        "0": "хӀокху минотехь",
        "future": {
          "one": "{0} мин. яьлча",
          "other": "{0} мин. яьлча"
        },
        "past": {
          "one": "{0} мин. хьалха",
          "other": "{0} мин. хьалха"
        }
      },
      "month": {
        "-1": "баханчу баттахь",
        "0": "карарчу баттахь",
        "1": "рогӀерчу баттахь",
        "future": {
          "one": "{0} бутт баьлча",
          "other": "{0} бутт баьлча"
        },
        "past": {
          "one": "{0} бутт хьалха",
          "other": "{0} бутт хьалха"
        }
      },
      "month-narrow": {
        "-1": "баханчу баттахь",
        "0": "карарчу баттахь",
        "1": "рогӀерчу баттахь",
        "future": {
          "one": "{0} б. баьлча",
          "other": "{0} б. баьлча"
        },
        "past": {
          "one": "{0} б. хьалха",
          "other": "{0} б. хьалха"
        }
      },
      "month-short": {
        "-1": "баханчу баттахь",
        "0": "карарчу баттахь",
        "1": "рогӀерчу баттахь",
        "future": {
          "one": "{0} б. баьлча",
          "other": "{0} б. баьлча"
        },
        "past": {
          "one": "{0} б. хьалха",
          "other": "{0} б. хьалха"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "one": "{0} квартал яьлча",
          "other": "{0} квартал яьлча"
        },
        "past": {
          "one": "{0} квартал хьалха",
          "other": "{0} квартал хьалха"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "one": "{0} кв. яьлча",
          "other": "{0} кв. яьлча"
        },
        "past": {
          "one": "{0} кв. хьалха",
          "other": "{0} кв. хьалха"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "one": "{0} кв. яьлча",
          "other": "{0} кв. яьлча"
        },
        "past": {
          "one": "{0} кв. хьалха",
          "other": "{0} кв. хьалха"
        }
      },
      "second": {
        "0": "хӀинца",
        "future": {
          "one": "{0} секунд яьлча",
          "other": "{0} секунд яьлча"
        },
        "past": {
          "one": "{0} секунд хьалха",
          "other": "{0} секунд хьалха"
        }
      },
      "second-narrow": {
        "0": "хӀинца",
        "future": {
          "one": "{0} сек. яьлча",
          "other": "{0} сек. яьлча"
        },
        "past": {
          "one": "{0} сек. хьалха",
          "other": "{0} сек. хьалха"
        }
      },
      "second-short": {
        "0": "хӀинца",
        "future": {
          "one": "{0} сек. яьлча",
          "other": "{0} сек. яьлча"
        },
        "past": {
          "one": "{0} сек. хьалха",
          "other": "{0} сек. хьалха"
        }
      },
      "week": {
        "-1": "даханчу кӀирнахь",
        "0": "карарчу кӀирнахь",
        "1": "рогӀерчу кӀирнахь",
        "future": {
          "one": "{0} кӀира даьлча",
          "other": "{0} кӀира даьлча"
        },
        "past": {
          "one": "{0} кӀира хьалха",
          "other": "{0} кӀира хьалха"
        }
      },
      "week-narrow": {
        "-1": "даханчу кӀирнахь",
        "0": "карарчу кӀирнахь",
        "1": "рогӀерчу кӀирнахь",
        "future": {
          "one": "{0} кӀир. даьлча",
          "other": "{0} кӀир. даьлча"
        },
        "past": {
          "one": "{0} кӀир. хьалха",
          "other": "{0} кӀир. хьалха"
        }
      },
      "week-short": {
        "-1": "даханчу кӀирнахь",
        "0": "карарчу кӀирнахь",
        "1": "рогӀерчу кӀирнахь",
        "future": {
          "one": "{0} кӀир. даьлча",
          "other": "{0} кӀир. даьлча"
        },
        "past": {
          "one": "{0} кӀир. хьалха",
          "other": "{0} кӀир. хьалха"
        }
      },
      "year": {
        "-1": "даханчу шарахь",
        "0": "карарчу шарахь",
        "1": "рогӀерчу шарахь",
        "future": {
          "one": "{0} шо даьлча",
          "other": "{0} шо даьлча"
        },
        "past": {
          "one": "{0} шо хьалха",
          "other": "{0} шо хьалха"
        }
      },
      "year-narrow": {
        "-1": "даханчу шарахь",
        "0": "карарчу шарахь",
        "1": "рогӀерчу шарахь",
        "future": {
          "one": "{0} ш. даьлча",
          "other": "{0} ш. даьлча"
        },
        "past": {
          "one": "{0} ш. хьалха",
          "other": "{0} ш. хьалха"
        }
      },
      "year-short": {
        "-1": "даханчу шарахь",
        "0": "карарчу шарахь",
        "1": "рогӀерчу шарахь",
        "future": {
          "one": "{0} ш. даьлча",
          "other": "{0} ш. даьлча"
        },
        "past": {
          "one": "{0} ш. хьалха",
          "other": "{0} ш. хьалха"
        }
      }
    },
    "locale": "ce"
  });
}